export enum TableButtonsEnum {
  NEXT = "NEXT",
  PREVIOUS = "PREVIOUS",
}
